"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayFilterNode = void 0;
const lodash_1 = __importDefault(require("lodash"));
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ARRAY-FILTER';
class ArrayFilterNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap, configFunctions, seedData) => {
            //Function id is in the form <name>::<version>
            const params = await this.asynchronousResolveInputs(nodeMap);
            try {
                const { input, data } = params;
                const filtered = [];
                const [functionName, versionString] = this.config.functionId.split("::");
                const map = (lodash_1.default.find(configFunctions[functionName].versions, { versionNumber: +versionString })).aggregateMap;
                const { inputName, outputName, inputArrayName, inputIndexName, inputData } = this.config;
                for (let i = 0; i < input.length; i++) {
                    const item = input[i];
                    const p = {};
                    p[inputName] = item;
                    if (inputArrayName) {
                        p[inputArrayName] = input;
                    }
                    if (inputIndexName) {
                        p[inputIndexName] = i;
                    }
                    if (inputData) {
                        p.data = data;
                    }
                    if ((await this.mapScenarios.FUNCTION_MAPPING.evaluate(map, Object.assign(Object.assign({}, this.accessorMap), { DATA: () => p }), configFunctions, seedData === null || seedData === void 0 ? void 0 : seedData.timestamp, (seedData === null || seedData === void 0 ? void 0 : seedData.parentNodeId) + '-' + i))[outputName]) {
                        filtered.push(item);
                    }
                }
                return {
                    filtered: filtered,
                };
            }
            catch (e) {
                console.error("ArrayFilter error: ", e.errorMessage);
                return null;
            }
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Array filter is not allowed as a synchronously resolving node');
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        this.config.type = this.config.type || 'Object';
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {
                filtered: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Filtered items',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        const schemas = this.schemaLookup.getFunctions()
            .map((schema) => schema.schemaId).sort((a, b) => a.toLocaleLowerCase() > b.toLocaleLowerCase() ? 1 : -1);
        const options = [];
        lodash_1.default.each(schemas, (item) => {
            const outputParams = this.schemaLookup.getFunctionOutput(item);
            const outputName = BaseNode_1.BaseNode.schemaMatchesType('Boolean', outputParams, 1);
            if (outputName) {
                const inputParams = this.schemaLookup.getFunctionInput(item);
                const inputData = inputParams.properties['data'] ? true : false;
                const extra = inputData ? 1 : 0;
                //Get functions with the signature of (<selectedType>) => bool
                let inputName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type, inputParams, 1 + extra, ['data']);
                if (inputName) {
                    options.push(item);
                    if (item === this.config.functionId) {
                        this.config.inputName = inputName;
                        this.config.inputArrayName = undefined;
                        this.config.inputIndexName = undefined;
                        this.config.outputName = outputName;
                        this.config.inputData = inputData;
                    }
                    return;
                }
                //Get functions with the signature of (<selectedType>, <selectedType>[]) => bool
                inputName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type, inputParams, 2 + extra, ['data']);
                let inputArrayName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type + ' Array', inputParams, 2 + extra, ['data']);
                if (inputArrayName && inputName) {
                    options.push(item);
                    if (item === this.config.functionId) {
                        this.config.inputName = inputName;
                        this.config.inputArrayName = inputArrayName;
                        this.config.inputIndexName = undefined;
                        this.config.outputName = outputName;
                        this.config.inputData = inputData;
                    }
                    return;
                }
                //Get functions with the signature of (<selectedType>, <selectedType>[], index:number) => bool
                inputName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type, inputParams, 3 + extra, ['index', 'data']);
                inputArrayName = BaseNode_1.BaseNode.schemaMatchesType(this.config.type + ' Array', inputParams, 3 + extra, ['data']);
                const inputIndexName = BaseNode_1.BaseNode.schemaMatchesType('Number', inputParams, 3 + extra, [inputName, 'data']);
                if (inputArrayName && inputArrayName && inputIndexName === 'index') {
                    options.push(item);
                    if (item === this.config.functionId) {
                        this.config.inputName = inputName;
                        this.config.inputArrayName = inputArrayName;
                        this.config.inputIndexName = 'index';
                        this.config.outputName = outputName;
                        this.config.inputData = inputData;
                    }
                    return;
                }
                //If we reach this point and the selected function id matches the current function,
                //the selected type must have changed, so the previously selected function is invalid, so clear config properties
                if (item === this.config.functionId) {
                    this.config.inputName = undefined;
                    this.config.outputName = undefined;
                    this.config.inputArrayName = undefined;
                    this.config.inputIndexName = undefined;
                    this.config.inputData = undefined;
                }
            }
        });
        const InputParams = {
            type: 'object',
            properties: {
                input: {
                    items: (this.config.inputName && this.config.functionId ? //If we have a selected config, pull the exact schema for the input - this is helpful for objects so their properties can be shown.
                     Object.assign(Object.assign({}, this.schemaLookup.getFunctionInput(this.config.functionId).properties[this.config.inputName]), { description: 'Item' }) :
                        BaseNode_1.BaseNode.getProp(this.config.type, 'Item')),
                    description: 'Items to Transform',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        if (this.config.inputData) {
            InputParams.properties['data'] = this.schemaLookup.getFunctionInput(this.config.functionId).properties['data'];
        }
        const ConfigParams = {
            type: 'object',
            properties: {
                type: BaseNode_1.BaseNode.getTypeOptions(false),
                functionId: {
                    description: 'Filter Function',
                    type: 'string',
                    enum: options,
                },
            },
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: ConfigParams });
    }
}
exports.ArrayFilterNode = ArrayFilterNode;
ArrayFilterNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Array Filter',
    isIdempotent: false,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ArrayFilter.js.map